import { LoanType } from '@/helpers/const';
import { CustomerApplicationProcessStep } from '@/types';
import type { LoanApplication } from '@/types';

/**
 * The first property step a new customer application is still missing, if any: Buying (unless it's an
 * equity release, which skips it) and Selling. Backstops submission for a journey saved after a step
 * was skipped, which the wizard still shows as completed.
 */
export const findMissingPropertyStep = (
  loanApp: Pick<LoanApplication, 'actionType' | 'loanType' | 'incomingProperties' | 'outgoingProperties'>,
) => {
  if (loanApp.actionType !== 'createNew') return undefined;
  if (loanApp.loanType !== LoanType.EQUITY_RELEASE && !loanApp.incomingProperties?.length) {
    return CustomerApplicationProcessStep.IncomingProperties;
  }
  if (!loanApp.outgoingProperties?.length) {
    return CustomerApplicationProcessStep.OutgoingProperties;
  }
  return undefined;
};
